import { Hotel } from 'models/index';
import { RootState } from '..';

export const getHotelData = (state: RootState): Hotel.Model => {
  return state.hotel.hotel;
};
